export class TaskUtilities {
  public static getTaskCompletionArray() {
    const completionArr: {visibleValue: string, value: number}[] = [];
    for (let i = 0; i <= 100; i += 25) {
      completionArr.push({ visibleValue: `${i}%`, value: i });
    }
    return completionArr;
  }
}
